import { ResolveFn } from '@angular/router';
import { ControlParams } from '../models/models.lib';
import { inject } from '@angular/core';
import { ControlParamsService } from '../control-params/control-params.service';

export const controlParamsResolver: ResolveFn<ControlParams> = (route, state) => {
  return inject(ControlParamsService).get();
};
